import {getUserId} from '@netx/core-user-next/utils/getUserId';
import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {
	assetPermissionChecker,
	currentUserIsAdmin,
	PermissionName,
	PermissionMatrixName,
} from '@netx/core-permissions-next';
import {type IAsset, AssetStatus} from '../schema';

export const canCheckIn = (asset?: IAsset) => {
	if (!asset) return false;

	const checkedOutBy = asset.checkout;
	if (checkedOutBy && !currentUserIsAdmin() && checkedOutBy !== getUserId())
		return false;

	if (!currentUserMeetsUserLevel(UserLevel.PRODUCER)) return false;
	// https://jira.netx.net/browse/DAM-13370
	if (
		![
			AssetStatus.NEARLINE,
			AssetStatus.ONLINE,
			AssetStatus.TEMP,
			AssetStatus.CHECKOUT,
		].includes(asset.status)
	)
		return false;

	return assetPermissionChecker({
		asset,
		permissionMatrixName: PermissionMatrixName.MODIFY,
		permissionName: PermissionName.MANAGE_VERSIONS,
	});
};
